"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "g214",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "17.08598137px",
      fontFamily: "sansSerif",
      letterSpacing: "0px",
      wordSpacing: "0px",
      fill: "currentColor",
      fillOpacity: "1",
      stroke: "none",
      strokeWidth: "2.84766388",
      id: "text303",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m 7.8675021,20.019391 v -9.635893 q 0,-0.750849 0.3420533,-1.1262734 0.3420534,-0.3754244 0.884333,-0.3754244 0.5589653,0 0.9010186,0.3754244 0.350396,0.3670816 0.350396,1.1262734 v 9.635893 q 0,0.759191 -0.350396,1.134616 -0.3420533,0.375424 -0.9010186,0.375424 -0.5339369,0 -0.884333,-0.375424 -0.3420533,-0.383768 -0.3420533,-1.134616 z",
        fontStyle: "normal",
        fontVariant: "normal",
        fontWeight: "normal",
        fontStretch: "normal",
        fontFamily: "Arial Rounded MT Bold",
        strokeWidth: "2.84766388",
        id: "path374"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m 14.641827,9.0903693 h 3.22865 q 1.259757,0 2.160776,0.2335974 0.901018,0.2335974 1.635181,0.8759903 1.910493,1.635182 1.910493,4.972287 0,1.101245 -0.191883,2.010607 -0.191884,0.909361 -0.592336,1.643524 -0.400453,0.725821 -1.02616,1.301472 -0.492224,0.442166 -1.076217,0.709134 -0.583994,0.266969 -1.259757,0.375425 -0.667422,0.108456 -1.510041,0.108456 h -3.22865 q -0.675763,0 -1.017817,-0.200227 -0.342053,-0.208569 -0.450509,-0.57565 -0.100113,-0.375425 -0.100113,-0.967761 v -8.968472 q 0,-0.800905 0.358739,-1.1596438 0.358738,-0.3587389 1.159644,-0.3587389 z m 0.959418,1.9605497 v 8.30105 h 1.877122 q 0.617364,0 0.96776,-0.03337 0.350396,-0.03337 0.725821,-0.166855 0.375424,-0.133484 0.650736,-0.375424 1.243071,-1.051189 1.243071,-3.62076 0,-1.81038 -0.550622,-2.711398 -0.54228,-0.901019 -1.343185,-1.142959 -0.800905,-0.250283 -1.935521,-0.250283 z",
        fontStyle: "normal",
        fontVariant: "normal",
        fontWeight: "normal",
        fontStretch: "normal",
        fontFamily: "Arial Rounded MT Bold",
        strokeWidth: "2.84766388",
        id: "path376"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      id: "g372",
      transform: "matrix(2.9537663,0,0,2.9537663,-6.9106814,-11.182339)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        strokeWidth: "0.72110814",
        id: "line329",
        y2: "7.2763853",
        x2: "4.2637987",
        y1: "4.3919535",
        x1: "4.2637987"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        strokeWidth: "0.72110814",
        id: "line331",
        y2: "5.8341694",
        x2: "5.7060151",
        y1: "5.8341694",
        x1: "2.8215823"
      })]
    })]
  })
}));